import React, { useRef } from 'react';
import { RiLightbulbFlashLine } from "react-icons/ri";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import JsonData from "../JsonData/jsonData.json";
import "./styles.css";
import { Navigation, Mousewheel, Keyboard, Autoplay } from 'swiper/modules';

const WhyThis = () => {
  const sliderRef = useRef(null);

  const handlePrev = () => {
    if (sliderRef.current && sliderRef.current.swiper) {
      sliderRef.current.swiper.slidePrev();
    }
  };

  const handleNext = () => {
    if (sliderRef.current && sliderRef.current.swiper) {
      sliderRef.current.swiper.slideNext();
    }
  };

  return (
    <>
      <Swiper
        ref={sliderRef}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        slidesPerView={1}   // 👈 default (mobile first)
        spaceBetween={20}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        }}
        modules={[Autoplay, Navigation, Mousewheel, Keyboard]}
        className="2xl:w-9/12 xl:w-11/12 w-11/12 mx-auto mySwiper"
      >
        {JsonData.whyThisData.map((items, index) => {
          return (
            <>
              <SwiperSlide key={index} className="flex bg-[#E91E63]/10 rounded-3xl">
                <div className="w-full bg-[#E91E63]/10 border border-[#E91E63]/10 rounded-3xl p-10 min-h-[380px] transition-all duration-300 hover:border-[#E91E63] hover:shadow-3xl">
                  <div className="flex flex-col items-center text-center space-y-8">
                    <RiLightbulbFlashLine size={46} className="textcolor" />
                    <p
                      className="text-[17px] text-[#2E3A39] font-medium leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: items.text }}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </>
          );
        })}
      </Swiper>
    </>
  );
};

export default WhyThis;
